export enum AreaUpdateType {
	Init,
	Change,
	Delete,
}

export enum AreaContentType {
	None,
	Color,
	Image,
	Disco,
	Speeddating,
}

export type AreaUpdateInit = {
	type: AreaUpdateType.Init
	url?: string
	title?: string
	imageUrl?: string
	iconUrl?: string
	description?: string
	position: { x: number; y: number }
	size: { width: number; height: number }
	backgroundColor: string
}

export type AreaUpdateChange = {
	type: AreaUpdateType.Change
	areas: Record<string, Area>
}

export type AreaUpdateDelete = {
	type: AreaUpdateType.Delete
	key: string
}

export type AreaUpdate = AreaUpdateInit | AreaUpdateChange | AreaUpdateDelete

export type Area = {
	key: string
	url?: string
	title?: string
	imageUrl?: string
	iconUrl?: string
	description?: string
	contentType?: AreaContentType
	position: { x: number; y: number }
	size: { width: number; height: number }
	backgroundColor?: string
}
